import Link from "next/link";
import React, { ReactElement } from "react";
import { blue, gray } from "../../theme";
import LinkedIcon from "@icons/linkedinIcon.svg";
import TwitterIcon from "@icons/twitterIcon.svg";
import GithubIcon from "@icons/githubIcon.svg";
import { Text } from "@kunduz/ui-atoms";
import styles from "./teamMember.module.scss";

export const TeamMember = (props: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <img src={props.imageUrl} alt={props.name} className={styles.image} />
      <Text variant="textlg" weight="semibold" color={gray[900]}>
        {props.name}
      </Text>
      <Text variant="textmd" color={blue[700]} style={{ marginBottom: 16 }}>
        {props.position}
      </Text>
      <div className={styles.linkWrapper}>
        {props.twitter && (
          <Link href={props.twitter}>
            <TwitterIcon />
          </Link>
        )}
        {props.linkedin && (
          <Link href={props.linkedin}>
            <LinkedIcon />
          </Link>
        )}
        {props.github && (
          <Link href={props.github}>
            <GithubIcon />
          </Link>
        )}
      </div>
    </div>
  );
};

interface Props {
  imageUrl: string;
  name: string;
  position: string;
  twitter?: string;
  linkedin?: string;
  github?: string;
}
